module.exports = __webpack_public_path__ + "static/media/Q3-2.d4478d90.jpg";